<template>
  <div class="flex flex-col md:flex-row rounded p-4 md:py-3 bg-white job-card__item">
    <div class="flex flex-row justify-between items-start md:items-center">
      <div class="w-32 h-32 mr-4">
        <img :src="job.logo" class="self-start md:self-center rounded p-2 border-2 border-solid border-lightgray"
             alt="jobImage"/>
      </div>
      <div class="flex items-center job-card__time md:hidden">
        <div class="flex flex-col items-end">
          <div class="flex flex-row items-center mb-2">
            <clock-icon size="1x" class="mr-1 cursor-pointer clock-icon"></clock-icon>
            <span class="text-normal text-gray text-xs">{{daysAgo(job.from)}}</span>
          </div>
          <div v-if="job.premium" class="w-16 h-6 flex items-center justify-center rounded bg-danger job-card__hot-job">
            <span class="text-white text-xs font-bold">{{this.$t('common.hotjob')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-full mt-4 md:mt-0">
      <div class="flex flex-row items-center justify-between">
        <router-link class="text-xl font-bold text-black overflow-hidden job__card-title" :to="`/${job.slug}`"
                     @click.native="setJob(job)">
          {{job.title}}
        </router-link>
        <div class="not-visible items-center flex-col job-card__time md:flex">
          <div class="flex flex-row items-center mb-1">
            <clock-icon size="1x" class="mr-1 cursor-pointer clock-icon"></clock-icon>
            <span class="text-sm text-gray">{{daysAgo(job.from)}}</span>
          </div>
          <div v-if="job.premium"
               class="ml-3 w-16 h-6 flex items-center self-end justify-center rounded bg-danger job-card__hot-job not-visible md:flex">
            <span class="text-white text-xs font-bold">{{this.$t('common.hotjob')}}</span>
          </div>
        </div>
      </div>
      <div class="flex flex-row flex-wrap justify-start job-card__details-subtitle">
                <span class="flex items-center mt-1 text-sm font-bold">
                    {{job.organisation_name}}
                </span>
        <span class="flex items-center mt-1 mx-3 text-sm">
                    <map-pin-icon size="1x" class="mr-1 cursor-pointer location-icon"></map-pin-icon>
                    {{job.location_name}}
                </span>
        <span v-if="job.salary_min" class="flex items-center mt-1 job-salary">
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wallet"
                         class="svg-inline--fa fa-wallet fa-w-16 w-4 mr-2"
                         role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="var(--color-primary)"
                              d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"></path>
                    </svg>
                    <span class="text-sm">€{{job.salary_min}} - €{{job.salary_max}}</span>
                </span>
      </div>
      <p class="font-medium mt-2 text-sm">
        {{getDescription(job.description)}}
      </p>
      <div v-if="segments" class="flex-row mt-2 flex-wrap not-visible md:flex">
        <div v-for="(segment, index) in segmentsText" :key="index"
             class="rounded-full py-1 px-3 mt-2 mr-2 text-xs text-primary-darker font-semibold bg-primary-lighter cursor-pointer segment-tag">
          <p class="font-semibold">{{segment.value}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ClockIcon, MapPinIcon } from 'vue-feather-icons'
  import { formatDistance, subDays, parseISO } from 'date-fns'
  import { enUS, nl } from 'date-fns/locale'

  const locales = { enUS, nl }

  export default {
    name: 'job-item',
    components: {
      ClockIcon,
      MapPinIcon
    },
    props: {
      job: {
        type: Object,
        default: () => ({})
      },
      segments: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        currentLanguage: ''
      }
    },
    mounted() {
      this.currentLanguage = this.$store.getters['getCurrentLanguage']
    },
    computed: {
      segmentsText() {
        let { segments } = this.job
        const allSegments = []

        for (const category in segments) {
          const categorySegments = segments[category]
          categorySegments.forEach(segmentId => {
            const segmentInfo = this.$store.getters['getSegmentsById'][segmentId]
            if (segmentInfo) {
              allSegments.push(segmentInfo)
            }
          })
        }
        return allSegments.slice(0, 5)
      }
    },
    methods: {
      daysAgo(created) {
        try {
          const date = parseISO(created)
          const createdDate = new Date(date)
          const now = new Date()
          const locale = locales[this.currentLanguage]
          return formatDistance(subDays(createdDate, 0), now, { locale: locale })
        } catch (e) {
          return 'N/A'
        }
      },
      setJob(job) {
        this.$store.commit('SET_CURRENT_JOB', job)
      },
      getDescription(text) {
        if(!text) {
          return ''
        }
        if (text.length > 100) {
          text = text.substr(0, 100) + '...'
        }
        return text
      }
    }
  }
</script>
